<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { type MenuItem } from "../../lib/helpers/steps/menuItems";
  import Typography from "../Typography.svelte";
  import VariationPills from "./VariationPills.svelte";

  const dispatch = createEventDispatcher();
  export let active: boolean = false;
  export let item: MenuItem;
  export let unavailable: boolean = false;
  export let selectedVariation: string | undefined = undefined;
  export let useThickActiveBorder: boolean = false;
</script>

<button
  class="flex bg-white menu-item-card w-full gap-6 p-3 text-left rounded-2xl"
  class:active
  class:unavailable
  class:use-thick-active-border={useThickActiveBorder}
  on:click={() => !unavailable && dispatch("click")}
  aria-label={item.visible_name}>
  <img src={item.image} alt={item.visible_name} class="aspect-square w-full rounded-xl overflow-hidden object-cover" />
  <div class="description-section flex flex-col h-full w-full py-3">
    <Typography mobile={TypographyType.Body1Semibold} desktop={TypographyType.Headline4}>
      {item.visible_name}
    </Typography>
    <div class="description flex-grow mt-1">
      <Typography mobile={TypographyType.Body2Regular} desktop={TypographyType.Body1Medium}>
        {item.description ?? ""}
      </Typography>
    </div>
    <VariationPills item={item} selectedVariation={selectedVariation} />
  </div>
</button>

<style>
  .menu-item-card:hover,
  .menu-item-card.active {
    border: 1px solid var(--color-grayscale-40);
  }

  .menu-item-card.active.use-thick-active-border {
    border: 4px solid var(--color-blue-50);
    padding: calc(0.75rem - 3px);
  }

  .description-section {
    min-height: 8.75rem;
  }

  .menu-item-card img {
    min-width: 8.75rem;
    width: 8.75rem;
    height: 8.75rem;
  }

  .menu-item-card .description {
    color: var(--color-grayscale-90);
  }
</style>
